export default "__VITE_ASSET__C3uSJoaz__ 720w";